module.exports = __webpack_public_path__ + "media/img/favicon/browserconfig-e91f205dfe6a4fe32f53d64758f667d9.xml";